import { IconButton } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import { getInfosDashboard } from '@webapps/business';
import { Modal, useAuth, useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../theme';
import DescriptionEdit from './EditContent/DescriptionEdit';

const {
  colors: { background, subTextColor },
} = theme;

const Description = ({ presentation }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);
  const { idUser } = useAuth();

  const [editDescription, setEditDescription] = useState(false);

  const { data: dashboardInfo = {}, refetch } = useQuery(getInfosDashboard, {
    key: 'infoDashboardSchool',
    variables: { id: idUser },
    fetchPolicy: 'network-only',
  });

  const handleOpenEditDescription = () => {
    setEditDescription(true);
  };
  const handleCloseEditDescription = () => {
    setEditDescription(false);
    refetch();
  };

  return (
    <div className={classes.container} style={{ marginTop: 20 }}>
      <div className={classes.editContainer}>
        <div className={global.title}>
          <FormattedMessage id="business.vitrine.description" />
        </div>
        <div style={{ marginTop: spacing(1) }} className={global.subTitle}>
          <FormattedMessage id="business.vitrine.descriptionSub" />
        </div>
      </div>
      <div className={classes.modifyLink}>
        <DescriptionEdit
          close={handleCloseEditDescription}
          presentation={presentation}
        />
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    background,
    borderRadius: 10,
    padding: '20px',
  },
  infoContainer: {
    marginTop: spacing(3),
  },
  info: {
    '& > *': {
      marginBottom: spacing(1),
    },
  },
  infoTitle: {
    fontWeight: 600,
  },
  editContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    marginBottom: spacing(2),
  },
  modifyLink: {
    color: '#152652',
    a: {
      textDecoration: 'none',
      color: '#0183FF',
    },
  },
});

Description.propTypes = {
  presentation: PropTypes.string,
};

export default Description;
